import { createFileRoute } from '@tanstack/react-router';
import { JourneysManualSegmentTabHandoff } from '@/pages/workspaces/segments/[segmentId]/overview/routing';

/**
 * The bare `journeys` segment URL, which is the Overview tab there and what every segment link names. It reads the segment and
 * forwards a manual one to the tab's own URL, leaving any other with the embedded app.
 */
function JourneysSegmentIndexRoute() {
  const { segmentId } = Route.useParams();

  return <JourneysManualSegmentTabHandoff segmentId={segmentId} tab="overview" />;
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/segments/$segmentId/')({
  component: JourneysSegmentIndexRoute,
});
